/* eslint-disable */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { View, Image } from 'react-native'
import styles from './Styles/FooterPostWallStyle'
import ImageAndText from './ImageAndText'

import { Images, Fonts } from '../Themes'
import FootterWallActions from '../Redux/FootterWallRedux'

class FooterPostWall extends Component {
  constructor(props) {
    super(props);
    this.eyeNotBlinkingStyle = {top: -3, left: 3, width: 48, height: 30}
    this.viewCountStyle = {fontFamily: Fonts.style.font.bold, width: 40}
    const { style = null } = this.props
    this.containerStyle = [styles.container, style]
  }

  showCommentDialog = (defaultTab, asPopup) => this.props.popup (defaultTab, asPopup)

  showHashTag = () => {
    this.props.showHasTag({ data: this.props.data, isonHashtag: !this.props.isonHashtag, hastagIndex: this.props.indexRow })
  }

  localOnLovePress = (...args) => this.props.onLovePress(...args)

  localShowComment = () => this.showCommentDialog('Comments') // orig way

  localShowCommentAsPopup = () => this.showCommentDialog('Comments', true)

  localShowHashTags = () => this.showCommentDialog('Hashtags')

  localShowActionSheet = () => this.props.showActionSheet()

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.NumComments != nextProps.NumComments ||
        this.props.NumLikes != nextProps.NumLikes || 
        this.props.NumViews != nextProps.NumViews)
      return true
    return false
  }

  render() {
    const { NumComments, NumLikes, NumViews, isText = false,
      showActionSheet, isShopping = false ,
      onLovePress,
      userLovesPost,
      onPressShoping,
      onSharePress,
      style = null
    } = this.props
    // <Image source={Images.eyeNotBlinking} style={this.eyeNotBlinkingStyle}/>
    return (
      <View style={this.containerStyle}>
        <ImageAndText
          extraTextStyle={this.viewCountStyle}
          isText
          text={NumViews}
					source={Images.eyeNotBlinking}
          imageStyle={this.eyeNotBlinkingStyle}/>
        <ImageAndText
          onPress={this.localOnLovePress}
          isText
          text={NumLikes}
          imageStyle={styles.image}
          source={userLovesPost ? Images.lovesOnIcon: Images.lovesOffIcon}/>
        <ImageAndText
          onPress={this.localShowCommentAsPopup}
          isText
          text={NumComments}
          imageStyle={styles.image} 
          source={NumComments ? Images.commentsOnIcon : Images.commentsOffIcon}/>
        <ImageAndText
          onPress={this.localShowHashTags}
          isText
          text={` `}
          imageStyle={styles.image}
          source={Images.hashTagsIcon}/>
        <ImageAndText
          onPress={this.localShowActionSheet}
          isText
          text={` `}
          imageStyle={styles.image}
          source={Images.optionsIcon}/>
        <ImageAndText
          onPress={onSharePress}
          imageStyle={styles.image}
          source={Images.shareIconBlack}/>
        <View>
        </View>
      </View>
    )
/*
        <ImageAndText
          onPress={this.nullPress}
          isText
          text={``}>
          <Image style={styles.image} source={Images.space} />
        </ImageAndText>
*/
  }
}
const mapStateToProps = state => {

  return {
    options: state.postCreation.basePostWallOptions,
    isonHashtag: state.footerWall.isonHashtag
  }
}

const mapDispatchToProps = dispatch => ({
  showHasTag: (data) => dispatch(FootterWallActions.showHashTag(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(FooterPostWall)
